(function () {
  'use strict';

  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  function getStorageKey(root) {
    var section = root.closest('[data-shopify-editor-section]');
    var sectionId = section && section.getAttribute('data-shopify-editor-section');

    if (!sectionId) {
      sectionId = root.getAttribute('data-section-id') || root.id || 'default';
    }

    return 'hero-slider-active-index-' + sectionId;
  }

  function readStoredIndex(key) {
    try {
      var value = window.sessionStorage.getItem(key);
      var index = parseInt(value, 10);
      return isNaN(index) ? 0 : index;
    } catch (e) {
      return 0;
    }
  }

  function writeStoredIndex(key, index) {
    try {
      window.sessionStorage.setItem(key, String(index));
    } catch (e) {}
  }

  function HeroSlider(root) {
    this.root = root;
    this.slides = Array.prototype.slice.call(root.querySelectorAll('[data-hero-slide]'));
    this.dots = Array.prototype.slice.call(root.querySelectorAll('[data-hero-dot]'));
    this.prev = root.querySelector('[data-hero-prev]');
    this.next = root.querySelector('[data-hero-next]');
    this.storageKey = getStorageKey(root);
    this.index = 0;
    this.timer = null;
    this.interval = parseInt(root.getAttribute('data-interval'), 10) || 6000;
    this.autoplay = root.getAttribute('data-autoplay') === 'true' && !prefersReduced.matches && !(window.Shopify && window.Shopify.designMode);

    this.restore();

    if (this.slides.length <= 1) return;

    this.bind();
    if (this.autoplay) this.play();
  }

  HeroSlider.prototype.bind = function () {
    var self = this;

    this.dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        self.goTo(parseInt(dot.getAttribute('data-hero-dot'), 10));
        self.restart();
      });
    });

    if (this.prev) this.prev.addEventListener('click', function () { self.go(-1); self.restart(); });
    if (this.next) this.next.addEventListener('click', function () { self.go(1); self.restart(); });

    this.root.addEventListener('mouseenter', function () { self.pause(); });
    this.root.addEventListener('mouseleave', function () { if (self.autoplay) self.play(); });
    this.root.addEventListener('focusin', function () { self.pause(); });
    this.root.addEventListener('focusout', function (e) {
      if (!self.root.contains(e.relatedTarget) && self.autoplay) self.play();
    });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) self.pause();
      else if (self.autoplay) self.play();
    });

    this.root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { self.go(-1); self.restart(); }
      else if (e.key === 'ArrowRight') { self.go(1); self.restart(); }
    });

    prefersReduced.addEventListener('change', function (e) {
      self.autoplay = self.root.getAttribute('data-autoplay') === 'true' && !e.matches;
      if (self.autoplay) self.play(); else self.pause();
    });
  };

  HeroSlider.prototype.goTo = function (i, skipStore) {
    if (i === this.index) return;
    var prev = this.slides[this.index];
    var next = this.slides[i];
    if (!next) return;

    if (prev) {
      prev.classList.remove('is-active');
      prev.setAttribute('aria-hidden', 'true');
      prev.setAttribute('inert', '');
    }

    next.classList.add('is-active');
    next.removeAttribute('aria-hidden');
    next.removeAttribute('inert');

    if (this.dots[this.index]) {
      this.dots[this.index].classList.remove('is-active');
      this.dots[this.index].setAttribute('aria-selected', 'false');
    }
    if (this.dots[i]) {
      this.dots[i].classList.add('is-active');
      this.dots[i].setAttribute('aria-selected', 'true');
    }

    this.index = i;
    if (!skipStore) writeStoredIndex(this.storageKey, i);
  };

  HeroSlider.prototype.restore = function () {
    var storedIndex = readStoredIndex(this.storageKey);
    if (storedIndex > 0 && storedIndex < this.slides.length) {
      this.goTo(storedIndex, true);
    }
  };

  HeroSlider.prototype.go = function (delta) {
    var n = this.slides.length;
    this.goTo((this.index + delta + n) % n);
  };

  HeroSlider.prototype.play = function () {
    var self = this;
    this.pause();
    this.timer = window.setInterval(function () { self.go(1); }, this.interval);
  };

  HeroSlider.prototype.pause = function () {
    if (this.timer) { window.clearInterval(this.timer); this.timer = null; }
  };

  HeroSlider.prototype.restart = function () {
    if (this.autoplay) this.play();
  };

  function init() {
    document.querySelectorAll('[data-hero-slider]').forEach(function (el) {
      if (!el.__heroSlider) el.__heroSlider = new HeroSlider(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-hero-slider]');
    if (el) el.__heroSlider = new HeroSlider(el);
  });
})();
